import React, {FC} from 'react';
import logoMovilidad from "../Assets/tmp_logo_movilidad.png";

export const Footer: FC = () => {
		return <div style={{
				backgroundColor: 'white',
				width: '100%',
				position: 'fixed',
				bottom: 0,
				zIndex: 100,
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				paddingBottom: 10,
				paddingTop: 5,
				flexDirection: 'row',
				paddingInline: 20
		}}>
				{/*<span className={style.legal}>{Config.webVersion}</span>*/}
				<img src={logoMovilidad} alt="logo movilidad" style={{height: 70}}/>
		</div>
};